import Image from "next/image";
import { FC } from "react";
import Typography from "../Typography";

// Typography doesn't expose a `blockquote` semantic variant, so the
// component renders the raw element with the equivalent Tailwind
// classes from the existing h3 scale. Typography is still imported
// for the attribution name/role below.

type TestimonialBlockProps = {
  quote?: string;
  name?: string;
  role?: string;
  avatarSrc?: string;
};

// Per CONTENT_HANDOFF.md §1: "If no real testimonial available at
// launch, hide the block. Do NOT ship placeholder copy." When the
// data file passes `quote: undefined` (the v2 default for pages
// awaiting sourcing), this component renders nothing.
const TestimonialBlock: FC<TestimonialBlockProps> = ({
  quote,
  name,
  role,
  avatarSrc,
}) => {
  if (!quote) return null;

  return (
    <section className="max-w-3xl mx-auto px-3 md:px-12 my-32 md:my-48 text-center">
      <blockquote className="text-slate-900 italic leading-snug text-3xl md:text-4xl font-semibold font-display">
        &ldquo;{quote}&rdquo;
      </blockquote>
      {(name || role || avatarSrc) && (
        <div className="mt-8 flex items-center justify-center gap-3">
          {avatarSrc && (
            <Image
              src={avatarSrc}
              alt={name ?? "Klap customer"}
              width={48}
              height={48}
              className="w-12 h-12 rounded-full object-cover"
            />
          )}
          <div className="text-left">
            {name && (
              <Typography variant="subtitle1" className="text-slate-900">
                {name}
              </Typography>
            )}
            {role && (
              <Typography variant="caption" className="text-slate-500">
                {role}
              </Typography>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default TestimonialBlock;
